module.exports = __webpack_public_path__ + "static/img/1.f2683bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/sp/1.png
// module id = Byin
// module chunks = 0